<template>
  <div class="wpdonation-box">
    <h2 class="wpdonation-title" v-if="strings">{{ strings.title }}</h2>

    <div class="easy-donation-box">
      <div class="single-credit-cardd">
        <div class="wpcm-row wpmc-justify-content-center">
          <div class="wpcm-col-md-6">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('first_name')"
                v-model="store.billing_fields.first_name"
                :disabled="store.loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-6">
            <div class="textfield">
              
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="email"
                :placeholder="trans('email')"
                v-model="store.billing_fields.email"
                :readonly="is_logged_in && email"
                :disabled="store.loading"
                required
              />
            </div>
          </div>
          <div class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('address')"
                :disabled="store.loading"
                v-model="store.billing_fields.address"
              />
            </div>
          </div>
          <div v-if="show_company" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('company')"
                :disabled="store.loading"
                v-model="store.billing_fields.zip"
              />
            </div>
          </div>
          <div v-if="show_country" class="wpcm-col-md-12">
            <div class="textfield">
              <el-select
                filterable
                :placeholder="trans('country')"
                :loading="select_loading"
                @change="setBillingValue('base_country', $event)"
                v-model="store.billing_fields.country"
              >
                <el-option
                  v-for="(name, key) in countries"
                  :key="key"
                  :label="name"
                  :value="key">
                </el-option>
              </el-select>
              
            </div>
          </div>
          <div v-if="show_county" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('county')"
                :disabled="store.loading"
                v-model="store.billing_fields.state"
              />
            </div>
          </div>
          <div v-if="show_city" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('city')"
                :disabled="store.loading"
                v-model="store.billing_fields.city"
              />
            </div>
          </div>
          <div v-if="show_phone_no" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('phone_no')"
                :disabled="store.loading"
                v-model="store.billing_fields.zip"
              />
            </div>
          </div>
          <div v-if="show_postal" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('postal_code')"
                :disabled="store.loading"
                v-model="store.billing_fields.zip"
              />
            </div>
          </div>
          <div v-if="show_tax" class="wpcm-col-md-12">
            <div class="textfield">
              <input
                type="text"
                :placeholder="trans('tax_code')"
                :disabled="store.loading"
                v-model="store.billing_fields.zip"
              />
            </div>
          </div>
          <div v-if="show_anonymous_donation" class="wpcm-col-md-12 wpcm-anonymous-field">
            <el-checkbox
              v-model="store.billing_fields.anonymous_donation"
              :disabled="store.loading"
            >
              {{ trans('anonymous_donation') }}
            </el-checkbox>
          </div>
          <div
            v-if="show_fee_recovery && fee_recovery_optin_mode === 'donor'"
            class="wpcm-col-md-12 wpcm-fee-recovery-field"
          >
            <el-checkbox
              v-model="store.extras.fee_recovery_optin"
              :disabled="store.loading"
            >
              {{ feeRecoveryMessage }}
            </el-checkbox>
            <div
              v-if="fee_recovery_show_breakdown && store.extras.fee_recovery_optin"
              class="wpcm-fee-recovery-breakdown"
            >
              {{ feeRecoveryBreakdown }}
            </div>
          </div>
          <div
            v-else-if="show_fee_recovery && fee_recovery_optin_mode === 'forced'"
            class="wpcm-col-md-12 wpcm-fee-recovery-field wpcm-fee-recovery-forced"
          >
            <span>{{ feeRecoveryMessage }}</span>
            <div v-if="fee_recovery_show_breakdown" class="wpcm-fee-recovery-breakdown">
              {{ feeRecoveryBreakdown }}
            </div>
          </div>
          <div v-if="enable_test_card_information" class="wpcm-col-md-12 wpcm-test-card-info">
            <p class="wpcm-test-card-text" v-html="trans('test_card_information')"></p>
          </div>
        </div>
      </div>
    </div>

    <slot></slot>
  </div>
</template>
  
<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue';
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps([
  "is_logged_in", "email", 'show_country', 'show_county', 'show_city', 'show_postal',
  'show_tax', 'show_phone_no', 'show_company', 'show_anonymous_donation',
  'enable_test_card_information', "strings",
  'show_fee_recovery', 'fee_recovery_optin_mode', 'fee_recovery_optin_message',
  'fee_recovery_show_breakdown', 'fee_recovery_mode', 'fee_recovery_global',
  'fee_recovery_per_gateway', 'fee_recovery_currency'
]);
const countries = ref([]);
const select_loading = ref(false);
const country = ref('');
const lifeline_donation = globalThis.lifeline_donation;

const setValue = (key, val) => {
  store[key] = val;
};
const setBillingValue = (key, val: Event) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if (props.strings) {
    return props.strings[key];
  }
};
const getCountries = () => {
  select_loading.value = true;

  const $ = jQuery;

  $.ajax({
    url: lifeline_donation.homeurl+ '/wp-json/webinane-commerce/v1/countries',
    success: res => {
      countries.value = res.countries
    },
    complete: res => {
      select_loading.value = false
    }
  })
};

const feeRecoveryRate = computed(() => {
  const fallback = { percent: 0, flat: 0, max: 0 };
  if (props.fee_recovery_mode === 'per_gateway') {
    const map = props.fee_recovery_per_gateway || {};
    if (store.payment_method && map[store.payment_method]) {
      return map[store.payment_method];
    }
    const keys = Object.keys(map);
    if (keys.length > 0) {
      return map[keys[0]];
    }
  }
  return props.fee_recovery_global || fallback;
});

const feeRecoveryAmount = computed(() => {
  const base = parseFloat(String(store.amount)) || 0;
  if (base <= 0) return 0;
  const r: any = feeRecoveryRate.value || {};
  let fee = base * ((parseFloat(r.percent) || 0) / 100) + (parseFloat(r.flat) || 0);
  const max = parseFloat(r.max) || 0;
  if (max > 0 && fee > max) fee = max;
  return Math.max(0, Math.round(fee * 100) / 100);
});

const formatMoney = (n: number) => {
  const num = parseFloat(String(n)) || 0;
  return (props.fee_recovery_currency || '$') + num.toFixed(2);
};

const feeRecoveryMessage = computed(() => {
  const tpl = props.fee_recovery_optin_message || '';
  return tpl.replace('{fee_amount}', formatMoney(feeRecoveryAmount.value));
});

const feeRecoveryBreakdown = computed(() => {
  const donation = parseFloat(String(store.amount)) || 0;
  const opted = props.fee_recovery_optin_mode === 'forced' || !!store.extras.fee_recovery_optin;
  const fee = opted ? feeRecoveryAmount.value : 0;
  const total = donation + fee;
  const tpl = (props.strings && props.strings.fee_recovery_breakdown)
    || 'Donation: {donation}  +  Fee: {fee}  =  Total: {total}';
  return tpl
    .replace('{donation}', formatMoney(donation))
    .replace('{fee}', formatMoney(fee))
    .replace('{total}', formatMoney(total));
});

watch(
  [
    () => feeRecoveryAmount.value,
    () => store.amount,
    () => store.extras.fee_recovery_optin,
    () => props.fee_recovery_optin_mode,
    () => props.show_fee_recovery,
  ],
  () => {
    const opted = props.show_fee_recovery && (
      props.fee_recovery_optin_mode === 'forced' || !!store.extras.fee_recovery_optin
    );
    store.extras.fee_recovery_amount = opted ? feeRecoveryAmount.value : 0;
    store.extras.fee_recovery_base   = parseFloat(String(store.amount)) || 0;
  },
  { immediate: true }
);

onMounted(() => {
  if (props.show_fee_recovery && props.fee_recovery_optin_mode === 'forced') {
    store.extras.fee_recovery_optin = true;
  }
});

</script>